import { CommApiInstance } from "Utils/CommApiInstance";

export interface GameUsrEvntApiBody {
    prog1Yn: "Y" | "N" | string;
    prog2Yn: "Y" | "N" | string;
    prog3Yn: "Y" | "N" | string;
}

export interface GameUsrEvntApiResponse {
    apiHdr: {
        code: string;
        msg: string;
        respDtime: string;
        rqstTrxId: string;
        rqstDtime: string;
        lang: string;
        timeZone: string;
    };
    apiBody: GameUsrEvntApiBody;
}

const GameUsrEvntApi = async (
    gameSvcCd:string,
) : Promise<GameUsrEvntApiResponse> => {
    return await CommApiInstance.post(`game/${gameSvcCd}/usr/evnt`,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data as GameUsrEvntApiResponse);
}
export default GameUsrEvntApi;